import Vue from "vue";
import axios from "axios";
import Qs from "qs";
import AuthService from "@/services/auth.service";
import CryptoJS from "crypto-js";
import { MessageBox } from 'element-ui'
// import common from '@/utils/common'

/**
 * 超时
 */
axios.defaults.timeout = 60000;

axios.defaults.baseURL = "";

axios.defaults.retry = 4;

axios.defaults.retryDelay = 1000;

axios.interceptors.request.use(
  (config) => {
    // router.beforeEach((to, from, next) => {
    //   console.log(to,from)
    // })

    let token = Vue.cookie.getCookie("token");
    // let token = window.localStorage.getItem("tokenCookie")
    if (token !== undefined && token !== null && token) {
      config.headers.common["TOKEN"] = token;
    }
    if (
      (config.method === "post" || config.method === "put") &&
      config.headers["Content-Type"] != "application/json"
    ) {
      config.transformRequest = [
        function (data, header) {
          data = Qs.stringify(data);
          return data;
        },
      ];
    }
    // ie 缓存问题
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      if (config.method === "get") {
        config.params = {
          t: Date.parse(new Date()) / 1000,
          ...config.params,
        };
      }
    }

    config.headers.yangRetry = config.headers.yangRetry || 1;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

function logError() {
  Vue.local.clearLocal();
  Vue.cookie.removeCookie("token");
}

/**
 * 响应拦截
 */
axios.interceptors.response.use(
  (response) => {
    if (response.headers["x-record-count"] !== undefined) {
      response.data["xRecordCount"] = response.headers["x-record-count"];
    }
    return response.data;
  },
  (error) => {
    //     text = '请求错误(400)，请重新申请'
    //     text = '登录错误(401)，请重新登录'
    //     text = '拒绝访问(403)'
    //     text = '请求出错(404)'
    //     text = '请求超时(408)'
    //     text = '服务器错误(500)，请重启软件或切换功能页！'
    //     text = '服务未实现(501)'
    //     text = '网络错误(502)'
    //     text = '服务不可用(503)'
    //     text = '网络超时(504)'
    //     text = 'HTTP版本不受支持(505)'
    //     text = '网络连接出错'
    // text = '连接服务器失败,请退出重试!'

    // 倒计时时间
    let count = 3
    // 计时器ID
    let timer
    if (error.response) {
      switch (error.response.status) {
        case 401:
          Vue.local.clearLocal()
          Vue.cookie.removeCookie("LWToken")
          MessageBox.alert('您当前账号的访问令牌已经失效(长时间未操作或您的账号在别的地方登录会造成这种失效)，系统将自动退出到登录页面。', '提示', {
            confirmButtonText: `确定(${count}s)`,
            showClose: false,
            customClass: 'expired'
          }).then(() => {
            clearInterval(timer)
            window.open(Vue.prototype.filePre$.loginUrl + "/logout", "_self");
          })
          timer = setInterval(() => {
            if (count > 0) {
              document.querySelector('.el-message-box > .el-message-box__btns > .el-button span').innerHTML = `确定(${--count}s)`
            } else {
              clearInterval(timer)
              MessageBox.close()
              window.open(Vue.prototype.filePre$.loginUrl + "/logout", "_self");
            }
          }, 1000)
          return new Promise(() => {})
      }
    }
    return Promise.reject(error.response.data);
  }
);

let HttpService = axios;

export default HttpService;
